import { render, staticRenderFns } from "./component-ed6a5b36.vue?vue&type=template&id=f24fee80&scoped=true&"
import script from "./component-ed6a5b36.vue?vue&type=script&lang=js&"
export * from "./component-ed6a5b36.vue?vue&type=script&lang=js&"
import style0 from "./component-ed6a5b36.vue?vue&type=style&index=0&id=f24fee80&lang=scss&scoped=true&"
import style1 from "./component-ed6a5b36.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24fee80",
  null
  
)

export default component.exports